import React, { useEffect, useState } from "react";
import Edit from "../../../Assets/img/Edit.svg";
import Delet from "../../../Assets/img/Delete.svg";
import API from "../../Service/Baseservice";
import "../Category/Category.css";
import { useNavigate } from "react-router-dom";
import Loading from "../../../Loading/loading";
const Category = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [languageId, setLanguageId] = useState(1);

    useEffect(() => {
        fetchCategories();
    }, [languageId]);

    const fetchCategories = () => {
        setLoading(true);
        API.post("faqsCategory_list/condition", {
            search,
            status: statusFilter,
            language_id: languageId,
        })
            .then((res) => {
                const data = res.data?.data?.data || res.data?.data || [];
                setCategories(data);
            })
            .catch((err) => console.error("Error fetching categories:", err))
            .finally(() => setLoading(false));
    };

    const filteredCategories = categories
        .filter(item => item.active !== 4)
        .filter(item => {
            const matchesSearch = item.category?.toLowerCase().includes(search.toLowerCase());
            const matchesStatus =
                statusFilter === ""
                    ? true
                    : statusFilter === "active"
                        ? item.status === "active"
                        : item.status === "inactive";
            return matchesSearch && matchesStatus;
        });


    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";
        API.post("faqscategory_status/update", { category_id: id, status: newStatus })
            .then(() => fetchCategories())
            .catch((err) => console.error("Failed to update status:", err));
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };

    const confirmDelete = () => {
        if (!deleteId) return;
        API.post("faqscategory_delete/update", { category_id: deleteId, active: 4 })
            .then((res) => {
                console.log("Delete Response:", res.data);
                fetchCategories();
                setShowPopup(false);
                setDeleteId(null);
            })
            .catch((err) => console.error("Failed to delete Category:", err));
    };

    return (
        <div className="category-container1">

            <div className="category-header1">
                <h2 className="category-title1">FAQ Categories</h2>
                <button onClick={() => navigate("/categoryadd")} className="add-btn">
                    <strong>+</strong> Add Category</button>
            </div>

            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search Category"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Language</label>
                    <div className="category-input-container1">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                            }}
                            value={languageId}
                            className="category-input-field1"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>
            </div>


            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="category-grid2">
                        {filteredCategories.length > 0 ? (
                            filteredCategories.map((item) => (
                                <div className="category-card1" key={item.category_id}>
                                    <p>{item.category}</p>
                                    <div className="category-card-footer1">
                                        <div className="status-container">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatus(item.category_id, item.status)
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>


                                        <div className="action-buttons1">
                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="icon-edit"
                                                onClick={() =>
                                                    navigate(`/categoryedit/${item.category_id}`, { state: { category: item } })
                                                }
                                            />
                                            <img
                                                src={Delet}
                                                alt="Delete"
                                                className="icon-delete"
                                                onClick={() => handleDeleteClick(item.category_id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-faq-text">No FAQTags found.</p>
                        )}
                        {/* Delete Confirmation Popup */}
                        {showPopup && (
                            <div className="popup-overlay">
                                <div className="popup-box">
                                    <h3>Confirm Delete</h3>
                                    <p>Are you sure you want to delete this Category?</p>
                                    <div className="popup-buttons">
                                        <button
                                            className="cancel-btn "
                                            onClick={() => setShowPopup(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button className="btn delete-btn" onClick={confirmDelete}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default Category;
